import React, { useState, useEffect } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

const TopPerformingLoansChart = ({ selectedMonth = 0, monthlyData = {} }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    // If monthlyData is empty or doesn't have the selected month, use empty data
    const defaultData = [
      { name: 'Personal', value: 0 },
      { name: 'Mortgage', value: 0 },
      { name: 'Auto', value: 0 },
      { name: 'Home', value: 0 },
      { name: 'Others', value: 0 },
    ];
    
    setChartData(monthlyData[selectedMonth] || defaultData);
  }, [selectedMonth, monthlyData]);

  return (
    <div className="w-full h-[250px] overflow-x-auto scrollbar-hide md:overflow-x-visible">
      <div className="min-w-[500px] md:min-w-full h-full">
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 10,
            left: 10,
            bottom: 5,
          }}
        >
          <CartesianGrid
            stroke="#000000"
            horizontal={false}
            vertical={true}
            verticalCoordinatesGenerator={({ xAxis }) => {
              const { scale } = xAxis;
              const coordinates = [];

              if (scale && scale.domain && typeof scale.bandwidth === 'function') {
                const domain = scale.domain();
                domain.forEach((tick) => {
                  const x = scale(tick) + scale.bandwidth() / 2;
                  coordinates.push(x);
                });
              }

              return coordinates;
            }}
          />
          <XAxis 
            dataKey="name" 
            stroke="#cbd5e0" 
            tickLine={false}
            axisLine={{ stroke: "#cbd5e0" }}
            interval={0}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            tickFormatter={(value) => `₹${value / 1000}k`}
            stroke="#cbd5e0"
            tickLine={false}
            axisLine={{ stroke: "#cbd5e0" }}
            tick={{ fontSize: 12 }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1a202c',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
            }}
            itemStyle={{ color: '#fff' }}
            formatter={(value) => `₹${value.toLocaleString('en-IN')}`}
          />
          <Bar dataKey="value" fill="#ffd000" />
        </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TopPerformingLoansChart;
